import React, { useEffect, useState } from "react";
import { getAllCollegePagination } from "../../Services/MasterService";
import { toast } from "react-toastify";
import { createCollegeScholarship } from "../../Services/CollegeService";

const AddCollegeScholraship = ({ data, onClose, onCloseWithApi }) => {
    const [reqData, setReqData] = useState({
        id: "",
        college_id: "", 
        scholarship_name: "", 
        eligibility_criteria: "", 
        deadline: "", 
        award: "", 
        year: ""
    });
    const [loader, setLoader] = useState(false);
    const [college, setCollege] = useState([]);

    const handleChange = (field, value) => {
        setReqData({ ...reqData, [field]: value })
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoader(true);
        let { ok } = await createCollegeScholarship(reqData);
        if (ok) {
            toast.success("Success");
            onCloseWithApi();
        }
        setLoader(false);
    };

    const getAllCollegeCall = async () => {
        let { ok, data } = await getAllCollegePagination({});
        if (ok) {
            setCollege(data?.records);
        }
    };

    useEffect(() => {
        getAllCollegeCall();
        if (data?.data) {
            const { id, college_id, scholarship_name, eligibility_criteria, deadline, award, year } = data?.data;
            setReqData({ id, college_id, scholarship_name, eligibility_criteria, deadline, award, year })
        }
    }, []);

    return (
        <div
            className="modal custom-modal fade bank-details show"
            id="add_items"
            role="dialog"
            aria-modal="true"
            style={{
                display: "block",
                background: "rgb(0 0 0 / 50%)",
            }}
        >
            <form onSubmit={(e) => handleSubmit(e)}>
                <div className="modal-dialog modal-dialog-centered modal-md">
                    <div className="modal-content">
                        <div className="modal-header">
                            <div className="form-header text-start mb-0">
                                <h4 className="mb-0">{!reqData?.id ? "Add College Ranking" : "Edit College Ranking"}</h4>
                            </div>
                            <button
                                type="button"
                                className="close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                                onClick={() => onClose()}
                            >
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div className="modal-body">
                            <div className="bank-inner-details">
                                <div className="row">
                                    <div className="col-lg-12 col-md-12">
                                        <div className="form-group">
                                            <label>Scholarship Name</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Scholarship Name"
                                                required
                                                value={reqData?.scholarship_name}
                                                onChange={(e) => handleChange("scholarship_name", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Eligibility Criteria</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Eligibility Criteria"
                                                required
                                                value={reqData?.eligibility_criteria}
                                                onChange={(e) => handleChange("eligibility_criteria", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Deadline</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Deadline"
                                                required
                                                value={reqData?.deadline}
                                                onChange={(e) => handleChange("deadline", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Award</label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                placeholder="Award"
                                                required
                                                value={reqData?.award}
                                                onChange={(e) => handleChange("award", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>Year</label>
                                            <input
                                                type="number"
                                                className="form-control"
                                                placeholder="Year"
                                                required
                                                value={reqData?.year}
                                                onChange={(e) => handleChange("year", e?.target?.value)}
                                            />
                                        </div>
                                        <div className="form-group">
                                            <label>College</label>
                                            <select required value={reqData?.college_id} onChange={(e) => handleChange("college_id", e.target.value)} class="form-select" aria-label="Default select example">
                                                <option selected>Select College</option>
                                                {college?.map(obj =>
                                                    <>
                                                        <option value={obj?.id}>{obj?.name}</option>
                                                    </>
                                                )}
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="bank-details-btn">
                                <button
                                    data-bs-dismiss="modal"
                                    className="btn bank-cancel-btn me-2"
                                    onClick={() => onClose()}
                                    disabled={loader}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    className="btn bank-save-btn"
                                    disabled={loader}
                                >
                                    {loader ? "Loading..." : "Save"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
};

export default AddCollegeScholraship;